import antdEnUS from 'antd/es/locale/es_ES';
import enMsg from "../locales/es_Col.json";

const EsLang = {
  antd: antdEnUS,
  locale: 'en-COL',
  messages: {
    ...enMsg
  },
};
export default EsLang;
